import ItemsList from './itemsList';
export default ItemsList;